/**
 * @generated SignedSource<<3e42485ec2d674505f2d9e6e1587d228>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ParticipativeModuleVisualization_participativeModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "visualization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContributionsDataviz_visualization"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContributionsMap_map"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CityWalk_cityWalk"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ParticipativeModule",
  "abstractKey": null
};

node.hash = "4b1fa99429262c9e860ddf9de80ede15";

module.exports = node;
